var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreenCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.227 16.771a.778.778 0 010-1.099L6.74 12.16H4.47a.778.778 0 110-1.556h4.148a.778.778 0 01.778.778v4.148a.778.778 0 01-1.556 0v-2.27l-3.511 3.513a.778.778 0 01-1.1 0v-.002zM16.29 8.637a.778.778 0 01-.777.778h-4.148a.778.778 0 01-.778-.778V4.49a.778.778 0 111.556 0V6.76l3.51-3.512a.778.778 0 111.1 1.099l-3.511 3.512h2.271a.778.778 0 01.778.778z"
  })));
}
export default SvgFullScreenCloseIcon;